<div class="menu-exhibitor h100">
  <h3 *ngIf="rolesService.isSingleExhibitor() && !rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">{{ 'MENU_EXHIBITOR.TITLE_SINGLE_EXHIBITOR' | translate }}</h3>
  <h3 *ngIf="rolesService.isMultipleExhibitor() && !rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">{{ 'MENU_EXHIBITOR.TITLE_MULTIPLE_EXHIBITOR' | translate }}</h3>
  <h3 *ngIf="rolesService.hasRoles([roles['BACKOFFICE'], roles['SUPERADMIN']])">{{ 'MENU_EXHIBITOR.TITLE_ADMIN' | translate }}</h3>
  <ul class="list-group mg-b20">
    <li class="list-group-item" (click)="goTo('utilInfo')" [ngClass]="{ 'active': isActive('util-info') }">
      {{ 'MENU_EXHIBITOR.UTIL_INFO' | translate }}
    </li>
    <li class="list-group-item" (click)="goTo('exhibitors')" [ngClass]="{ 'active': isActive('exhibitors') }">
      {{ 'MENU_EXHIBITOR.EXHIBITORS' | translate }}
    </li>
  </ul>
</div>
